import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import BillingAddress from '../../../components/V2/BillingAddress';
import PaymentInfoV2 from '../../../components/V2/PaymentInfoV2';
import ContactInfo from '../../../components/V2/ContactInfo';
import SubscriptionItem from './components/SubscriptionItem';
import OrderHistory from './components/OrderHistory';
import { NavigationHeader } from 'onramp/ui/components';
import { Box, Hr, Text, Flex } from 'core/ui/atoms';
import { GET_PROGRAM_DETAIL } from 'core/api/apollo/queries';
import { isLoading } from 'core/api/loadingHelpers';
import Loading from 'core/ui/components/Loading';
import { invoicesPath } from 'onramp/api/navigation';
import ResponsiveView from 'core/ui/components/ResponsiveView';

const MySettingsPage = () => {
  const history = useHistory();
  const { loading, error, refetch, data: { getProgramDetail = {} } = {} } = useQuery(GET_PROGRAM_DETAIL);

  const goToInvoicePath = () => history.push(invoicesPath());

  if (isLoading(loading, getProgramDetail, error)) {
    return <Loading />;
  }

  return (
    <Box>
      <NavigationHeader title='My Settings' />
      <Hr />
      <Title>My Subscriptions</Title>
      <SubscriptionItem refetch={refetch} item={getProgramDetail} />
      <Hr />
      <ResponsiveView desktop={true}>
        <BillingContainer direction='row' justifyContent='center' gap='40px'>
          <Box>
            <BillingAddress title='Delivery Address' />
            <PaymentInfoV2 title='My Payment Methods' />
          </Box>
          <DetailsSecondView gap='40px' direction='row' alignItems='center' justifyContent='center'>
            <Title>My Invoices</Title>
            <UnderLineText onClick={goToInvoicePath}>View Invoices</UnderLineText>
          </DetailsSecondView>
        </BillingContainer>
      </ResponsiveView>
      <ResponsiveView desktop={false}>
        <Container>
          <Title>Personal Details</Title>
          <ContactInfo title='' />
        </Container>
        <Hr />
        <Container>
          <Title>My Payments Methods</Title>
          <PaymentInfoV2 title=' ' />
        </Container>
        <Hr />
        <Title>Default Shipping Address</Title>
        <Container>
          <BillingAddress title='' />
        </Container>
        <Hr />
        <Title>My Invoices</Title>
        <Flex direction='row' alignItems='center' justifyContent='center'>
          <UnderLineText onClick={goToInvoicePath}>View Invoices</UnderLineText>
        </Flex>
        <Hr />
        <OrderHistory />
      </ResponsiveView>
    </Box>
  );
};

const BillingContainer = styled(Flex)`
  margin-top: 50px;
`;

const DetailsSecondView = styled(Flex)`
  p {
    margin: 0px;
  }
`;

const Container = styled(Box)`
  padding-left: 10px;
  padding-right: 10px;
`;

const UnderLineText = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  text-decoration: underline;
  text-underline-offset: 5px
`;

const Title = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`;

export default MySettingsPage;
